import { Player } from "@lottiefiles/react-lottie-player";
import { useNavigate } from "react-router-dom";



export default function NotFound() {
    // states
    const navigate = useNavigate();


    // comportements
    // const handlerefresh = () => {
    //     window.location.reload();
    // }


    // affichage
    return (
        <div className="uk-uk-child-width-1-1 uk-grid">
            <div className="mb-3 mt-5">
                <Player
                    autoplay
                    loop
                    src="/assets/imgs/404_error.json"
                    style={{ height: '360px', width: '360px', display: "block", marginLeft: "auto", marginRight: "auto", marginTop: 200 }}
                    >
                </Player>
            </div>
            <div className="mb-3 p-3 text-center">
                <p className='text-center text-dark' style={{fontSize: 24, marginTop: -96}}>Page not available at the moment or expired!</p>
                <button type="button" onClick={() => navigate(-1)} className="btn btn-dark">
                    <i className="fa fa-reply" style={{marginRight: 8}}></i> Go Back
                </button>
            </div>
        </div>
    )
}